import React from 'react';
import LoadingOverlay from '../../components/animations/LoadingOverlay';

const Loader = () => {
  return (
    <LoadingOverlay visible={true} text="Loading..." />
  );
};

export default Loader;

